import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { goToTop } from 'react-scrollable-anchor';

class ScrollToTop extends Component {
    componentDidUpdate(prevProps) {
      if (this.props.location.pathname !== prevProps.location.pathname) {
        goToTop();
      }
    }
  
    render() {
      return this.props.children;
    }
  }
  
  export default withRouter(ScrollToTop);


// WEBPACK FOOTER //
// ./src/components/ScrollToTop.js